export enum HeadcountSettingDropdownItemsType {
  Mail = 'Mail'
}
